export const dashboardTypes = {
  DASHBOARD_ONCHANGE: "DASHBOARD_ONCHANGE",
};
